module.exports = __webpack_public_path__ + "static/media/black-white.0559b7db.png";